import React, { forwardRef, useRef, useEffect, useImperativeHandle } from 'react';
import { usePortal } from '@pansy/use-portal';
import { useMap } from "../map";
import { usePropsReactive, isFun } from "../utils";
import { buildCreateOptions } from "../utils/control";
import { allProps, setterMap, converterMap } from "./config";
import { jsx as _jsx } from "react/jsx-runtime";
export var Marker = /*#__PURE__*/forwardRef(function () {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var ref = arguments.length > 1 ? arguments[1] : undefined;
  var _useMap = useMap(),
    map = _useMap.map,
    AMap = _useMap.AMap;
  var _usePortal = usePortal(),
    container = _usePortal.container,
    Portal = _usePortal.Portal;
  var instanceObj = useRef(null);
  var _usePropsReactive = usePropsReactive(props, instanceObj, {
      setterMap: setterMap,
      converterMap: converterMap
    }),
    onInstanceCreated = _usePropsReactive.onInstanceCreated;
  useEffect(function () {
    if (map) {
      createInstance().then(function () {
        onInstanceCreated === null || onInstanceCreated === void 0 ? void 0 : onInstanceCreated(instanceObj.current);
      });
    }
  }, [map]);
  useImperativeHandle(ref, function () {
    return instanceObj.current;
  }, [instanceObj.current]);
  var createInstance = function createInstance() {
    var options = buildCreateOptions(props, allProps, converterMap);
    options.map = map;
    var marker = new AMap.Marker(options);
    instanceObj.current = marker;
    setMarkerLayout(props);
    return Promise.resolve();
  };
  var setMarkerLayout = function setMarkerLayout(props) {
    if ('render' in props || 'children' in props && props.children) {
      createContentWrapper();
      if ('className' in props && props.className) {
        container.className = props.className;
      }
    }
  };
  var createContentWrapper = function createContentWrapper() {
    instanceObj.current.setContent(container);
  };
  var children = props.render || props.children;
  if (isFun(children)) {
    children = children();
  }
  if (children) {
    return /*#__PURE__*/_jsx(Portal, {
      children: children
    });
  }
  return null;
});